import config from './config';
import md5 from './md5';

/*
 * Builds a signed data.laddition.com export URL, mirroring the v4 front helper
 * (app/front/src/lib/utils.ts -> getDataScript). The signature is
 * md5(`${db}#${last 5 digits of the current unix timestamp in seconds}`).
 */
export const getDataScript = (script, db, openingDate, closingDate) => {
	const baseSignature = `${db}#${Math.floor(Date.now() / 1000)
		.toString()
		.slice(-5)}`;
	const signature = md5(baseSignature);
	// config.dataUrl already ends with a trailing slash (e.g. https://data.laddition.com/)
	const dataUrl = config.dataUrl.replace(/\/$/, '');

	return `${dataUrl}/scripts/reporting/v1/${script}?db=${db}&date_start=${openingDate}&date_end=${closingDate}&signature=${signature}`;
};

export default getDataScript;
